export default "__VITE_ASSET__rIS75uL5__"